module.exports = __webpack_public_path__ + "img/church.6574b7ef.jpg";